import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { isNullAddress } from "@opensea/utils";
import { PreviewTooltip } from "@/components/tooltip/PreviewTooltip";
import { ProfilePreviewTooltipFragment } from "./ProfilePreviewTooltip.fragment";
import { ProfilePreviewTooltipContent } from "./ProfilePreviewTooltipContent";
export function ProfilePreviewTooltip(t0) {
  const $ = _c(11);
  let profileKey;
  let rest;
  if ($[0] !== t0) {
    ({
      profile: profileKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = profileKey;
    $[2] = rest;
  } else {
    profileKey = $[1];
    rest = $[2];
  }
  let profile;
  let t1;
  if ($[3] !== profileKey) {
    profile = readFragment(ProfilePreviewTooltipFragment, profileKey);
    t1 = isNullAddress(profile.address);
    $[3] = profileKey;
    $[4] = profile;
    $[5] = t1;
  } else {
    profile = $[4];
    t1 = $[5];
  }
  if (t1) {
    return rest.children;
  }
  let t2;
  if ($[6] !== profile) {
    t2 = <ProfilePreviewTooltipContent profile={profile} />;
    $[6] = profile;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== rest || $[9] !== t2) {
    t3 = <PreviewTooltip align="center" className="min-w-[340px] py-2.5" content={t2} {...rest} />;
    $[8] = rest;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}